import React from 'react';
import './SettingsPage.css';
import { SettingsPageHeader } from './SettingsPageHeader/SettingsPageHeader';
import { SecondaryButton } from '../Buttons/Buttons';

export interface SettingsPageProps {
	title: string;
	settings: React.ReactNode;
	canNavigateBack?: boolean;
	onNavigatingBack?: () => void;
	showRestoreDefaults?: boolean;
	onRestoreDefaults?: () => void;
	isRestoreDefaultsDisabled?: boolean;
	/** Optional content rendered on the right side of the header (e.g. search) */
	headerAction?: React.ReactNode;
}

export const SettingsPage: React.FC<SettingsPageProps> = ({
	title,
	settings,
	canNavigateBack = false,
	onNavigatingBack,
	showRestoreDefaults = false,
	onRestoreDefaults,
	isRestoreDefaultsDisabled = false,
	headerAction,
}) => {
	return (
		<div className="settings-page-container">
			<div className="settings-page-content">
				<SettingsPageHeader
					title={title}
					canNavigateBack={canNavigateBack}
					onNavigatingBack={onNavigatingBack}
					headerAction={headerAction}
				/>
				{settings}
				{showRestoreDefaults && onRestoreDefaults && (
					<div className="settings-page-restore-defaults">
						<SecondaryButton
							onClick={onRestoreDefaults}
							disabled={isRestoreDefaultsDisabled}
							ariaLabel="Restore default settings"
						>
							Restore default settings
						</SecondaryButton>
					</div>
				)}
			</div>
		</div>
	);
};
